import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { useErrorPaths } from '../hooks';
import { errorTypeSelector } from '../store';

function OfferErrorRenderer() {
    const errorPathsMap = useErrorPaths();

    const errorType = useSelector(errorTypeSelector);

    if (!errorType) {
        return null;
    }

    return (
        <Navigate replace
            to={ errorPathsMap[errorType] }
        />
    );
}

export default memo(OfferErrorRenderer);
